const form = {
  formId: "sign-in-form",
  formField: {
    firstname: {
      name: "firstname",
      label: "First name",
      placeholder: "First name",
    },
    lastname: {
      name: "lastname",
      label: "Last name",
      placeholder: "Last name",
    },
    email: {
      name: "email",
      label: "Email",
      placeholder: "Email",
    },
    password: {
      name: "password",
      label: "Password",
      placeholder: "Password",
    },
    repeatPassword: {
      name: "repeatPassword",
      label: "Repeat password",
      placeholder: "Repeat password",
    },
  },
};

export default form;
